import type { Colleague } from './transfer'
import type { CounterView, Ticket } from './types'

/** Who sent this customer on, as "D2 · Anna": the desk, the person, or both. null
 *  when nobody did; '' when somebody did but neither name is known here. */
export function transferredFromName(
  ticket: Pick<Ticket, 'transferredFrom'>,
  counters: readonly CounterView[],
  colleagues: readonly Colleague[],
): string | null {
  const from = ticket.transferredFrom
  if (!from) return null
  const desk = from.counterId ? counters.find((c) => c.counterId === from.counterId)?.name : undefined
  const person = from.staffId
    ? (colleagues.find((c) => c.id === from.staffId)?.displayName ?? counters.find((c) => c.staffId === from.staffId)?.staffName)
    : undefined
  return [desk, person].filter(Boolean).join(' · ')
}
